import React, { Component } from "react";
import { PaymentMethod, RefundTypes, SliderSettings, TicketType, TransportationMethod, TransportationType } from "../Constant";
import MyContext from "./MyContext";
import { withTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import sv from "date-fns/locale/sv";

export class MyProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stops: [],
      lines: [],
      trainStations: [],
      allowFileUploadExtension: props.allowFileUploadExtension,
      totalCostSEKMax: props.totalCostSEKMax,
      ...this.getInitialState(),
    };
  }
  getInitialState = () => ({
    /* state props */
    activeSlide: SliderSettings.initialSlide,
    registrationNumber: "",
    trainNumber: 0,
    otherComments: "",
    fromAddress: "",
    toAddress: "",
    numberOfKmDriven: "",
    transportationType: TransportationType.USEOWNCAR,
    ticketType: TicketType.COMMUTER,
    accommodationTotalCost: "",
    foodTotalCost: "",
    transportTotalCost: "",
    personalID: "",
    hasPersonalID: true,
    mobileNumber: "",
    firstname: "",
    surname: "",
    streetNameAndNumber: "",
    postalCode: "",
    city: "",
    clearingNumber: "",
    bankAccount: "",
    biljettnummerValue: "",
    departureStation: null,
    departureDate: null,
    departureTime: null,
    email: "",
    emailConfirm: "",
    username: "",
    arrivalStation: null,
    foodReceipt: [],
    transportReceipt: [],
    accommodationReceipt: [],
    refundType: RefundTypes.VIASUS,
    departureTimeOptions: null,
    agreePersonalDataProcessing: false,
    declareInformation: false,
    consensus: false,
    distance: {},
    status: false,
    transportationMethod: TransportationMethod.BUS,
    line: null,
    ticketInfo: null,
    IBAN: "",
    BIC: "",
    payoutOption: PaymentMethod.SWISH,
    countryCode: { code: "SE", label: "Sweden", phone: "46" },
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };

  locales = { en: undefined, sv };

  render() {
    const currentLocale = this.locales[this.props.i18n.language];
    return (
      <MyContext.Provider
        value={{
          countryCode: this.state.countryCode,
          changeCountryCode: (countryCode) => {
            this.setState({ countryCode });
          },
          ticketInfo: this.state.ticketInfo,
          changeTicketInfo: (ticketInfo) => {
            this.setState({ ticketInfo });
          },
          stops: this.state.stops,
          changeStops: (stops) => {
            this.setState({ stops });
          },
          lines: this.state.lines,
          changeLines: (lines) => {
            this.setState({ lines });
          },
          status: this.state.status,
          changeStatus: (status) => {
            this.setState({ status });
          },
          activeSlide: this.state.activeSlide,
          changeActiveSlide: (activeSlide) => {
            this.setState({ activeSlide });
          },
          registrationNumber: this.state.registrationNumber,
          changeRegistrationNumber: (registrationNumber) => {
            this.setState({ registrationNumber });
          },
          totalCostSEKMax: this.state.totalCostSEKMax,
          changeTotalCostSEKMax: (totalCostSEKMax) => {
            this.setState({ totalCostSEKMax });
          },
          distance: this.state.distance,
          changeDistance: (distance) => {
            this.setState({ distance });
          },
          allowFileUploadExtension: this.state.allowFileUploadExtension,
          changeAllowFileUploadExtension: (allowFileUploadExtension) => {
            this.setState({ allowFileUploadExtension });
          },
          consensus: this.state.consensus,
          changeConsensus: (consensus) => {
            this.setState({ consensus });
          },
          agreePersonalDataProcessing: this.state.agreePersonalDataProcessing,
          changeAgreePersonalDataProcessing: (agreePersonalDataProcessing) => {
            this.setState({ agreePersonalDataProcessing });
          },
          declareInformation: this.state.declareInformation,
          changeDeclareInformation: (declareInformation) => {
            this.setState({ declareInformation });
          },
          departureTimeOptions: this.state.departureTimeOptions,
          changeDepartureTimeOptions: (departureTimeOptions) => {
            this.setState({ departureTimeOptions });
          },
          trainStations: this.state.trainStations,
          changeTrainStations: (trainStations) => {
            this.setState({ trainStations });
          },
          trainNumber: this.state.trainNumber,
          changeTrainNumber: (trainNumber) => {
            this.setState({ trainNumber });
          },
          transportationType: this.state.transportationType,
          changeTransportationType: (transportationType) => {
            this.setState({ transportationType });
          },
          refundType: this.state.refundType,
          changeRefundType: (refundType) => {
            this.setState({ refundType });
          },
          fromAddress: this.state.fromAddress,
          changeFromAddress: (fromAddress) => {
            this.setState({ fromAddress });
          },
          toAddress: this.state.toAddress,
          changeToAddress: (toAddress) => {
            this.setState({ toAddress });
          },
          numberOfKmDriven: this.state.numberOfKmDriven,
          changeNumberOfKmDriven: (numberOfKmDriven) => {
            this.setState({ numberOfKmDriven });
          },
          ticketType: this.state.ticketType,
          changeTicketType: (ticketType) => {
            this.setState({ ticketType });
          },
          accommodationTotalCost: this.state.accommodationTotalCost,
          changeAccommodationTotalCost: (accommodationTotalCost) => {
            this.setState({ accommodationTotalCost });
          },
          transportTotalCost: this.state.transportTotalCost,
          changeTransportTotalCost: (transportTotalCost) => {
            this.setState({ transportTotalCost });
          },
          foodTotalCost: this.state.foodTotalCost,
          changeFoodTotalCost: (foodTotalCost) => {
            this.setState({ foodTotalCost });
          },
          personalID: this.state.personalID,
          changePersonalID: (personalID) => {
            this.setState({ personalID });
          },
          hasPersonalID: this.state.hasPersonalID,
          changehasPersonalID: (hasPersonalID) => {
            this.setState({ hasPersonalID });
          },
          mobileNumber: this.state.mobileNumber,
          changeMobileNumber: (mobileNumber) => {
            this.setState({ mobileNumber });
          },
          streetNameAndNumber: this.state.streetNameAndNumber,
          changeStreetNameAndNumber: (streetNameAndNumber) => {
            this.setState({ streetNameAndNumber });
          },
          postalCode: this.state.postalCode,
          changePostalCode: (postalCode) => {
            this.setState({ postalCode });
          },
          city: this.state.city,
          changeCity: (city) => {
            this.setState({ city });
          },
          surname: this.state.surname,
          changeSurname: (surname) => {
            this.setState({ surname });
          },
          firstname: this.state.firstname,
          changeFirstname: (firstname) => {
            this.setState({ firstname });
          },
          bankAccount: this.state.bankAccount,
          changeBankAccount: (bankAccount) => {
            this.setState({ bankAccount });
          },
          clearingNumber: this.state.clearingNumber,
          changeClearingNumber: (clearingNumber) => {
            this.setState({ clearingNumber });
          },
          departureDate: this.state.departureDate,
          changeDepartureDate: (departureDate) => {
            this.setState({ departureDate });
          },
          departureTime: this.state.departureTime,
          changeDepartureTime: (departureTime) => {
            this.setState({ departureTime });
          },
          email: this.state.email,
          changeEmail: (email) => {
            this.setState({ email });
          },
          emailConfirm: this.state.emailConfirm,
          changeEmailConfirm: (emailConfirm) => {
            this.setState({ emailConfirm });
          },
          biljettnummerValue: this.state.biljettnummerValue,
          changeBiljettnummerValue: (biljettnummerValue) => {
            this.setState({ biljettnummerValue });
          },
          departureStation: this.state.departureStation,
          changeDepartureStation: (departureStation) => {
            this.setState({ departureStation });
          },
          arrivalStation: this.state.arrivalStation,
          changeArrivalStation: (arrivalStation) => {
            this.setState({ arrivalStation });
          },
          username: this.state.username,
          changeUsername: (username) => {
            this.setState({ username });
          },
          delay: this.state.delay,
          changeDelay: (delay) => {
            this.setState({ delay });
          },
          compensation: this.state.compensation,
          changeCompensation: (compensation) => {
            this.setState({ compensation });
          },
          otherComments: this.state.otherComments,
          changeOtherComments: (otherComments) => {
            this.setState({ otherComments });
          },
          foodReceipt: this.state.foodReceipt,
          changeFoodReceipt: (foodReceipt) => {
            this.setState({ foodReceipt });
          },
          transportReceipt: this.state.transportReceipt,
          changeTransportReceipt: (transportReceipt) => {
            this.setState({ transportReceipt });
          },
          accommodationReceipt: this.state.accommodationReceipt,
          changeAccommodationReceipt: (accommodationReceipt) => {
            this.setState({ accommodationReceipt });
          },
          transportationMethod: this.state.transportationMethod,
          changeTransportationMethod: (transportationMethod) => {
            this.setState({ transportationMethod });
          },
          line: this.state.line,
          changeLine: (line) => {
            this.setState({ line });
          },
          IBAN: this.state.IBAN,
          changeIBAN: (IBAN) => {
            this.setState({ IBAN });
          },
          BIC: this.state.BIC,
          changeBIC: (BIC) => {
            this.setState({ BIC });
          },
          payoutOption: this.state.payoutOption,
          changePayoutOption: (payoutOption) => {
            this.setState({ payoutOption });
          },
          resetState: () => {
            this.resetState();
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={currentLocale}>
          {this.props.children}
        </LocalizationProvider>
      </MyContext.Provider>
    );
  }
}

export default withTranslation()(MyProvider);
